var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["modal/modal-close.j2"] = require( "modal/modal-close.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/footer/sticky-email-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "core/templates/footer/sticky-email-form.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("validatedField")) {
var t_4 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_6 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_6);
if(t_1.hasOwnProperty("hasErrors")) {
var t_7 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_7);
output += "\n\n<div class=\"c-sticky-email-signup-form\">\n\n    <div class=\"o-row\">\n\n        <a class=\"c-sticky-email-signup__close js-sticky-email-signup__close\">\n            ";
env.getTemplate("modal/modal-close.j2", false, "core/templates/footer/sticky-email-form.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n        </a>\n\n        <form novalidate class=\"js-sticky-email-signup-form ";
output += runtime.suppressValue((lineno = 10, colno = 70, runtime.callWrap(t_7, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footer")),"emailSignup")),"messages")),"generalErrors")])), env.opts.autoescape);
output += "\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\" data-parsley-validate data-qa-signup-footer>\n\n            <div class=\"o-column o-extra-small--12 o-medium--6 o-large--4 o-large--offset-1\">\n\n                <h2 class=\"c-sticky-email-signup-form__h2\">\n                    ";
output += runtime.suppressValue((lineno = 15, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-header"])), env.opts.autoescape);
output += "\n                </h2>\n\n                <p class=\"c-sticky-email-signup-form__p\">\n                    ";
output += runtime.suppressValue((lineno = 19, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-copy"])), env.opts.autoescape);
output += "\n                </p>\n\n            </div>\n\n            <div class=\"o-row o-column o-extra-small--12 o-medium--6 o-large--4 o-large--offset-2\">\n\n                <div class=\"o-column o-extra-small--12 o-medium--8\">\n\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footer")),"emailSignup")),"messages")),"generalErrors")) {
output += "\n                        ";
output += runtime.suppressValue((lineno = 29, colno = 45, runtime.callWrap(t_6, "displayGeneralErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footer")),"emailSignup")),"messages")),"generalErrors")])), env.opts.autoescape);
output += "\n                    ";
;
}
output += "\n\n\n                    <div class=\"c-form__field c-form__field--required ";
output += runtime.suppressValue((lineno = 33, colno = 80, runtime.callWrap(t_7, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footer")),"emailSignup")),"messages")),"email")])), env.opts.autoescape);
output += "\">\n\n                        <label for=\"signup-email-sticky\" class=\"c-form__label\">\n                            ";
output += runtime.suppressValue((lineno = 36, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-email-label"])), env.opts.autoescape);
output += "\n                        </label>\n\n                        <input data-parsley-type=\"email\" ";
output += runtime.suppressValue((lineno = 39, colno = 72, runtime.callWrap(t_4, "validatedField", context, ["ERROR_EMAIL_SIGNUP_INVALID_USERNAME"])), env.opts.autoescape);
output += " value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footer")),"emailSignup")),"email"), env.opts.autoescape);
output += "\" type=\"email\" name=\"email\" id=\"signup-email-sticky\" class=\"c-form__text\" data-qa-sticky-signup-email-field />\n\n                        ";
output += runtime.suppressValue((lineno = 41, colno = 43, runtime.callWrap(t_5, "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footer")),"emailSignup")),"messages")),"email")])), env.opts.autoescape);
output += "\n\n                    </div>\n\n                </div>\n\n                <div class=\"o-column o-extra-small--12 o-medium--4\">\n\n                    <button type=\"submit\" class=\"c-button-primary js-sticky-email-signup\" data-email-signup-source=\"Site Footer\" data-qa-sticky-email-signup-button>\n                        ";
output += runtime.suppressValue((lineno = 50, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-submit-button"])), env.opts.autoescape);
output += "\n                    </button>\n\n                </div>\n\n            </div>\n\n        </form>\n\n    </div>\n\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12 o-medium--6 o-medium--offset-6 o-large--4 o-large--offset-7\">\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footer")),"emailSignup")),"signUpSuccessful")) {
output += "\n                <p class=\"u-success\" data-qa-success-msg>\n                    ";
output += runtime.suppressValue((lineno = 66, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-success-message",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                </p>\n            ";
;
}
output += "\n\n        </div>\n\n    </div>\n\n</div>\n\n<div class=\"c-sticky-email-signup-details\">\n\n    <div class=\"o-row\">\n\n        <div class=\"o-row o-column o-large--centered o-large--10\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <p class=\"c-sticky-email-signup-details__p\">\n                    ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, (lineno = 85, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-disclaimer"]))), env.opts.autoescape);
output += "\n                </p>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/footer/sticky-email-form.j2"] , dependencies)